export default class CountryAndStates {
	states = null;
	value = '';
	text = '';

	constructor(country) {
		this.value = country.Name;
		this.text = country.Name;
		this.states = country.States.map(item => ({
			abbreviation: item.Abbreviation,
			value: item.Name,
			text: item.Name,
		}));
	}
}



// WEBPACK FOOTER //
// ./src/api/models/CountryAndStates.js